import { render, staticRenderFns } from "./shopCommunityList.vue?vue&type=template&id=f042e0ee&scoped=true"
import script from "./shopCommunityList.vue?vue&type=script&lang=js"
export * from "./shopCommunityList.vue?vue&type=script&lang=js"
import style0 from "./shopCommunityList.vue?vue&type=style&index=0&id=f042e0ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f042e0ee",
  null
  
)

export default component.exports